import React, { PureComponent } from 'react';
import { Dropdown as SemanticDropdown } from 'semantic-ui-react';
import './Dropdown.css';
import { singleValueAttributeUpdater } from './utils/handler';
import message from '../../../helper/message';

export default class Dropdown extends PureComponent {
  onChange = (ev, { value }) => {
    singleValueAttributeUpdater(this.props, value);
  };

  render() {
    const {
      configuration,
      attributeName,
      appApi,
      disabled,
      options,
      value,
      onChange,
    } = this.props;
    const {
      label,
      placeholderText: placeholder,
      autoHide,
    } = appApi.config.getAttribute(attributeName);
    const dropdownOptions =
      options ||
      appApi.config.getAttributeAvailableValues(attributeName, configuration);
    if (autoHide && !dropdownOptions.length) return <div />;
    const dropdownValue = value || configuration[attributeName].value;
    // for dev, remove in product mode
    onChange &&
      message.warn(
        `The onchange function for ${attributeName} has been override, please take care of the import disable inside override function!`
      );
    /////////////
    return (
      <div className="attrContainer dropdownAttrContainer">
        {label && <div className="dropdownLabel label">{label}</div>}
        <SemanticDropdown
          selection
          disabled={disabled}
          value={dropdownValue}
          options={dropdownOptions}
          onChange={onChange || this.onChange}
          placeholder={`${placeholder}`}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/standardAttributes/Dropdown.js